// Typed answers of the compare/compat pair endpoints (contracts C6, C7). Kept
// out of endpoints.ts so pages that mock endpoints can still use them.

/** 409 `ingredients_pending`: that side's ingredient list is still with the team. */
export class IngredientsPendingError extends Error {
  side: 'a' | 'b';
  constructor(side: 'a' | 'b') {
    super(`The ingredients of Product ${side.toUpperCase()} are not ready yet`);
    this.name = 'IngredientsPendingError';
    this.side = side;
  }
}

/** 422 `same_product`: both sides hold the same product. */
export class SameProductError extends Error {
  constructor() {
    super('Pick two different products');
    this.name = 'SameProductError';
  }
}

export function isIngredientsPendingError(error: unknown): error is IngredientsPendingError {
  return error instanceof IngredientsPendingError;
}

export function isSameProductError(error: unknown): error is SameProductError {
  return error instanceof SameProductError;
}
